var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      ref: "dateMenu",
      attrs: {
        "no-title": "",
        "close-on-content-click": false,
        "return-value": _vm.date,
        transition: "scale-transition",
        "offset-y": "",
        "min-width": "290px",
        disabled: _vm.disabled,
      },
      on: {
        "update:returnValue": function ($event) {
          _vm.date = $event
        },
        "update:return-value": function ($event) {
          _vm.date = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        dense: "",
                        label: _vm.$vuetify.lang.t(
                          "webmap.featureTable.labels.value"
                        ),
                        "prepend-icon": "mdi-calendar",
                        readonly: "",
                      },
                      model: {
                        value: _vm.date,
                        callback: function ($$v) {
                          _vm.date = $$v
                        },
                        expression: "date",
                      },
                    },
                    "v-text-field",
                    attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dateOpen,
        callback: function ($$v) {
          _vm.dateOpen = $$v
        },
        expression: "dateOpen",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-date-picker",
        {
          attrs: { "no-title": "", scrollable: "" },
          model: {
            value: _vm.date,
            callback: function ($$v) {
              _vm.date = $$v
            },
            expression: "date",
          },
        },
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              class: _vm.buttonClass,
              attrs: { color: "primary" },
              on: { click: _vm.dateCancelClickHandler },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.btnTextCancel) + "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              class: _vm.buttonClass,
              attrs: { color: "primary" },
              on: { click: _vm.dateOKClickHandler },
            },
            [_vm._v("\n            " + _vm._s(_vm.btnTextOk) + "\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }